import { Card, CardHeader, CardTitle, CardDescription, CardContent } from '@/components/ui/Card'
import { Input } from '@/components/ui/Input'
import { Label } from '@/components/ui/Label'
import { AvatarUpload } from '@/components/ui/AvatarUpload'
import { TimezoneSelect } from '@/components/ui/TimezoneSelect'
import type { SettingsAccount } from '@/pages/Settings.types'

interface AccountDetailsCardProps {
  account: SettingsAccount
  timezoneOptions: Array<[string, string]>
  onLogoUpload: (file: File) => void
  onTimezoneChange: (value: string) => void
}

export function AccountDetailsCard({ account, timezoneOptions, onLogoUpload, onTimezoneChange }: AccountDetailsCardProps) {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Account Details</CardTitle>
        <CardDescription>Your workspace information</CardDescription>
      </CardHeader>
      <CardContent className="space-y-6">
        <div className="flex items-center gap-6 pb-6 border-b border-border">
          <AvatarUpload
            currentUrl={account.logo_url}
            initials={account.name.split(' ').map(n => n[0]).join('').slice(0, 2).toUpperCase()}
            onUpload={onLogoUpload}
            size="lg"
            label="Change logo"
          />
          <div>
            <p className="font-medium">{account.name}</p>
            <p className="text-sm text-muted-foreground">Account logo shown in widget</p>
          </div>
        </div>
        <div className="space-y-2">
          <Label>Account Name</Label>
          <Input value={account.name} disabled className="bg-muted" />
        </div>
        <div className="space-y-2">
          <Label>Account ID</Label>
          <Input value={account.slug} disabled className="bg-muted" />
        </div>
        <div className="space-y-2">
          <Label>Timezone</Label>
          <TimezoneSelect value={account.timezone} options={timezoneOptions} onChange={onTimezoneChange} />
          <p className="text-xs text-muted-foreground">
            Account-wide default. Agents inherit this unless they set their own in Profile.
          </p>
        </div>
      </CardContent>
    </Card>
  )
}
